import React, { Component } from "react";
import Images from "../../Images";
import { connect } from "react-redux";

export class BettingImg extends Component {
  render() {
    const { landingBettingImage , androidImage , appleImage , apkAppleLink , apkAndroidLink} = this.props;
    return (
      <div style={{position:"relative"}}>
        <img
          src={landingBettingImage}
          alt="betting-img"
          className="betting-img"
        />
        <div className="download-app-buttons">
        {apkAppleLink ? (
                  <a href={apkAppleLink} target="_blank">
                    <img
                      // style={{ height: "70px" }}
                      src={appleImage}
                      alt="apple-image"
                    />
                  </a>
                ) : (
                  <img
                    // style={{ height: "70px" }}
                    src={appleImage}
                    alt="apple-image"
                  />
                )}

                {apkAndroidLink ? (
                  <a href={apkAndroidLink} target="_blank">
                    <img
                      // style={{ height: "70px" }}
                      src={androidImage}
                      alt="android-image"
                    />
                  </a>
                ) : (
                  <img
                    // style={{ height: "70px" }}
                    src={androidImage}
                    alt="android-image"
                  />
                )}
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  return {
    androidImage: state.general.configuration.androidImage,
    appleImage: state.general.configuration.appleImage,
    apkAndroidLink: state.general.configuration.apkAndroidLink,
    apkAppleLink: state.general.configuration.apkAppleLink,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {

  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BettingImg);
